var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferendaConfirming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11032_44298)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_11032_44298)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 15.5C14.375 13.7741 15.7741 12.375 17.5 12.375H24.6283C25.5897 12.375 26.5118 12.7569 27.1916 13.4367L29.5633 15.8084C30.2431 16.4882 30.625 17.4103 30.625 18.3717V28.5C30.625 30.2259 29.2259 31.625 27.5 31.625H23C22.6548 31.625 22.375 31.3452 22.375 31C22.375 30.6548 22.6548 30.375 23 30.375H27.5C28.5355 30.375 29.375 29.5355 29.375 28.5V18.6251H26.5C25.3264 18.6251 24.375 17.6737 24.375 16.5001V13.625H17.5C16.4645 13.625 15.625 14.4645 15.625 15.5V19C15.625 19.3452 15.3452 19.625 15 19.625C14.6548 19.625 14.375 19.3452 14.375 19V15.5ZM25.625 13.8442V16.5001C25.625 16.9833 26.0168 17.3751 26.5 17.3751H29.1558C29.0395 17.1236 28.8791 16.892 28.6794 16.6923L26.3077 14.3206C26.108 14.121 25.8765 13.9605 25.625 13.8442ZM12.625 26.5C12.625 24.3599 14.3599 22.625 16.5 22.625C18.6401 22.625 20.375 24.3599 20.375 26.5C20.375 28.6401 18.6401 30.375 16.5 30.375C14.3599 30.375 12.625 28.6401 12.625 26.5ZM16.5 21.375C13.6695 21.375 11.375 23.6695 11.375 26.5C11.375 29.3305 13.6695 31.625 16.5 31.625C19.3305 31.625 21.625 29.3305 21.625 26.5C21.625 23.6695 19.3305 21.375 16.5 21.375ZM18.4739 25.9849C18.718 25.7408 18.718 25.3451 18.4739 25.101C18.2299 24.8569 17.8341 24.8569 17.5901 25.101L16.1172 26.5739L15.4111 25.8672C15.1672 25.623 14.7714 25.6229 14.5272 25.8668C14.2831 26.1108 14.2829 26.5065 14.5269 26.7507L15.6749 27.8997C15.7921 28.017 15.9511 28.0829 16.1169 28.083C16.2827 28.083 16.4417 28.0172 16.5589 27.8999L18.4739 25.9849Z",
    fill: "#1B202C",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11032_44298",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11032_44298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferendaConfirming);
export default __webpack_public_path__ + "static/media/referenda-confirming.1a709428c944b098bb1735dad3af9163.svg";
export { ForwardRef as ReactComponent };